module.exports = __webpack_public_path__ + "static/img/图层 25.467b3ab0.png";